export const GET_PROJECTS = 'GET_PROJECTS'
export const GET_SELECTED_PROJECTS = 'GET_SELECTED_PROJECTS'
